import type { NextStepValidationError } from 'models/purchaseFlow/nextStepValidationError'

/**
 * The gate's instructions codes, narrowed to what the client sees (QA-647): a day and an hour without minutes, and
 * a sole access mode shown as chosen whose contact is still empty. The hint and the blocked event read the same list.
 */
export const refineInstructionsErrors = (
  errors: NextStepValidationError[],
  ui: { meetingMinutesMissing?: boolean; meetingModeImplied?: boolean }
): NextStepValidationError[] => errors.map((code) => {
  if (code === 'meeting_date_invalid' && ui.meetingMinutesMissing) return 'meeting_minutes_missing'
  if (code === 'meeting_type_missing' && ui.meetingModeImplied) return 'meeting_name_invalid'
  return code
})
